<template>
  <transition name="fade">
    <section class="Loader" v-if="!store.state.isReady">
      <div>
        <img class="Login-logo" src="@/assets/images/kenzo-homme-logo.svg" alt="">
        <div class="BambouLoader">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 825.3 274.8" style="enable-background:new 0 0 825.3 274.8;" xml:space="preserve">
          <g ref="b3" id="BAMBOU_3" fill="white">
            <path d="M551.3,96.9v73.7h274l-42-53.5c-9.9-12.7-25.2-19.9-41.3-19.6C690.4,98.5,576.5,100.4,551.3,96.9z"/>
            <path d="M526.9,186.7c0,0-15.3,70.3-6.1,73.6c0,0,30.4-31.3,30.8-45.5c0,0,46.1,65.5,61.2,59.5c0,0-33.5-69.9-60.3-89.1
              L526.9,186.7z"/>
          </g>
          <g ref="b2" id="BAMBOU_2" fill="white">
            <path d="M529.9,97.2v73.4c0,0-234.4-8.4-252.6,0V83.3c0,0,47.3-14.4,116.7,2.1C394,85.4,472.4,83.3,529.9,97.2z"/>
          </g>
          <g ref="b1" id="BAMBOU_1" fill="white">
            <path d="M0,80v90.6c0,0,196.4-18.3,255.9,0V80c0,0-8.2-11.5-61.1,8.2C194.8,88.2,181.6,93.2,0,80z"/>
            <path d="M271.6,63.1c0,0,27.6-25.3,24.7-29.5c0,0-22.3,4.2-26.8,10.1c0,0,0.1-41.7-8.2-43.7c0,0-6.7,39.8-1.1,56L271.6,63.1z"/>
          </g>
          </svg>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import anime from 'animejs'
import emitter from '@/emitter'

export default {
  inject: ['store'],
  data () {
    return {
      animation: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.animation = anime({
        targets: [this.$refs.b1, this.$refs.b2, this.$refs.b3],
        opacity: [-1, 1],
        ease: 'steps(0)',
        duration: 1000,
        delay: anime.stagger(600, {start: 300}),
        loop: true,
      })
      emitter.on('LOADED', this.onLoaded)
      // setTimeout(() => {
      //   // emitter.off('LOADED', this.onLoaded)
      //   this.onLoaded()
      // }, 3000)
    })
  },
  beforeUnmount() {
    emitter.off('LOADED', this.onLoaded)
  },
  methods: {
    onLoaded() {
      setTimeout(() => {
        // emitter.off('LOADED', this.onLoaded)
        this.animation.reset()
        this.store.load()
      }, 3000)
    }
  }
}
</script>

<style lang="stylus">
.fade-enter-active,
.fade-leave-active
  transition: opacity 0.5s ease

.fade-enter-from,
.fade-leave-to
  opacity: 0

.Loader
  position fixed
  width 100%
  height 100%
  z-index 1000
  color white
  background-image url('../../assets/bali-background.jpg')
  background-size cover
  display flex
  align-items center
  justify-content center

.BambouLoader
  height 90px
  display flex
  align-items center
  svg
    width 160px
    margin 0 auto
    > g
      opacity 0
</style>